import { datadogRum } from '@datadog/browser-rum';
import { useCallback, useContext, useEffect, useMemo } from 'react';
import { isProd } from '~/constants/srp/environment';
import { useTotalMatchedInventory } from '~/context/srp/InventoryContext';
import ModalContext from '~/context/srp/ModalContext';
import {
  type Configuration,
  type OnError,
  type OnNudge,
  useNudgeManager
} from '~/utilities/NudgeManager';
import { logError } from '~/utilities/srp/errorHandlers';

declare global {
  interface Merch {
    totalMatchedInventory: number;
  }

  interface Window {
    merch: Merch;
  }
}

export default function useMerchWindowObject() {
  const totalMatchedInventory = useTotalMatchedInventory();

  useNudgeManager(
    useMemo<Partial<Configuration>>(() => ({ storageKey: 'srp-nudges' }), []),
    useContext(ModalContext).isAnyModalOpen,
    useCallback<OnNudge>((nudgeId, result) => {
      datadogRum.addAction('Nudge arrived', { nudgeId, ...result });

      if (!isProd) {
        console.debug('Nudge arrived', { nudgeId, ...result });
      }
    }, []),
    useCallback<OnError>((nudgeId, error) => {
      logError(error, { nudgeId });
    }, [])
  );

  useEffect(() => {
    window.merch = { ...window.merch, totalMatchedInventory };
  }, [totalMatchedInventory]);
}
